import { str } from "./str";

/** A blank field carries no meaning: it reads as absent, not as an empty value. */
export function trimmed(value: unknown): string | null {
  const text = str(value)?.trim();
  return text ? text : null;
}
